module.exports = __webpack_public_path__ + "img/icon-mobile.0af0e99b.svg";